import { Component, computed, inject, input, signal } from '@angular/core';
import { SensorBlockService } from '@artemis-software/wr-api';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { loader } from '@/utils/signals/loader';
import { useInterval } from '@/composables/useInterval';
import { Router } from '@angular/router';
import { CurrentUserService } from '@services/current-user.service';
import { isSensorInFlight } from '@/utils/sensor-status.util';

const POLL_INTERVAL_MS = 4000;

@Component({
  selector: 'wr-sensor-block-list',
  standalone: false,
  templateUrl: './sensor-block-list.component.html',
  styleUrl: './sensor-block-list.component.scss'
})
export class SensorBlockListComponent {
  readonly sensorBlockService = inject(SensorBlockService);
  readonly currentUserService = inject(CurrentUserService);

  readonly search = input.required<string | undefined>();

  refresh = input<number>(0);

  readonly innerRefresh = signal(0);

  readonly router = inject(Router);

  readonly canEditSensors = computed(() => this.currentUserService.hasPrivilege('editSensors'));

  readonly buildingId = input.required<string | null | undefined>();

  readonly loading = loader();

  readonly sensorBlocks = asyncComputed(() => {
    this.refresh();
    this.innerRefresh();
    return this.sensorBlockService.findAllDetailDtos({
      text: this.search() || undefined,
      buildingId: this.buildingId() ?? undefined,
      sort: { sort: 'name', order: 'ASC' },
      page: 0,
      size: 1000
    });
  }, [], this.loading);

  readonly anyInFlight = computed(() =>
    this.sensorBlocks().some((block) => block.sensors.some((sensor) => isSensorInFlight(sensor))),
  );

  readonly showSpinner = computed(() => this.loading() && this.sensorBlocks().length === 0);

  constructor() {
    useInterval(() => {
      if (this.anyInFlight()) {
        this.innerRefresh.update((value) => value + 1);
      }
    }, POLL_INTERVAL_MS);
  }

  addNewSensorBlock() {
    this.router.navigate(['sensorBlock', 'new'], { queryParams: { buildingId: this.buildingId() } });

  }

  onRefresh() {
    this.innerRefresh.update(value => value + 1);
  }
}
